import { create } from 'zustand';
import { useShellStore } from '@renderer/app/state/shell-store';
import type { TaskStatus, TaskViewMode } from '@shared/types';

export type TasksSort = 'recent';

interface TasksViewStore {
  scopeFilter: 'all';
  labelFilter: 'all' | string;
  projectFilter: 'all' | string;
  sort: TasksSort;
  query: string;
  dragTaskId: string | null;
  dragStatus: TaskStatus | null;
  highlightTaskId: string | null;
  setScopeFilter: (value: 'all') => void;
  setLabelFilter: (value: 'all' | string) => void;
  setProjectFilter: (value: 'all' | string) => void;
  setSort: (value: TasksSort) => void;
  setQuery: (value: string) => void;
  setViewMode: (value: TaskViewMode) => Promise<void>;
  startDragging: (taskId: string, status: TaskStatus) => void;
  clearDragState: () => void;
  setHighlightTaskId: (taskId: string | null) => void;
}

export const useTasksViewStore = create<TasksViewStore>((set) => ({
  scopeFilter: 'all',
  labelFilter: 'all',
  projectFilter: 'all',
  sort: 'recent',
  query: '',
  dragTaskId: null,
  dragStatus: null,
  highlightTaskId: null,
  setScopeFilter: (scopeFilter) => set({ scopeFilter }),
  setLabelFilter: (labelFilter) => set({ labelFilter }),
  setProjectFilter: (projectFilter) => set({ projectFilter }),
  setSort: (sort) => set({ sort }),
  setQuery: (query) => set({ query }),
  setViewMode: async (tasksViewMode) => {
    await useShellStore.getState().savePreferences({ tasksViewMode });
  },
  startDragging: (dragTaskId, dragStatus) => set({ dragTaskId, dragStatus }),
  clearDragState: () => set({ dragTaskId: null, dragStatus: null }),
  setHighlightTaskId: (highlightTaskId) => set({ highlightTaskId })
}));
